// The admin site is the Supabase Site URL, so a customer can land here (a recovery link, or a sign-in by mistake). The staff check
// (`GET /staff/session`) refuses a session that is not staff with 403, and the auth provider then signs it out. Without a word the visitor
// would see the sign-in page and not know why (CHT-1628 item 6). The provider leaves a one-shot marker; the sign-in page shows the notice.
// The marker holds no data: only the time. It expires, so a notice never shows on a later, unrelated visit.

const KEY = "lafayette.admin.staff-access-denied";
const MAX_AGE_MS = 2 * 60 * 1000;

export const STAFF_ACCESS_DENIED_NOTICE =
  "This account is not authorized for the staff console, so it was signed out. To reset a customer password, open the reset link, choose a new password, then return to the app and sign in.";

type NoticeStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export function markStaffAccessDenied(storage: NoticeStorage, now = Date.now()): void {
  try {
    storage.setItem(KEY, String(now));
  } catch {
    // Storage may be unavailable: the visitor is still signed out, only without the notice.
  }
}

/** Reads the marker without removing it, so a render that React repeats (StrictMode) sees the same answer. */
export function hasStaffAccessDenied(storage: NoticeStorage, now = Date.now()): boolean {
  try {
    const stored = storage.getItem(KEY);
    if (stored === null) return false;
    const markedAt = Number(stored);
    return Number.isFinite(markedAt) && now - markedAt >= 0 && now - markedAt <= MAX_AGE_MS;
  } catch {
    return false;
  }
}

export function clearStaffAccessDenied(storage: NoticeStorage): void {
  try {
    storage.removeItem(KEY);
  } catch {
    // Nothing to do.
  }
}
